import React from "react";

import "../../scss/molecules/_header-title.scss";

class HeaderTitle extends React.Component {
  render() {
    var pronoun, title, lastnoun;
    if (this.props.title) {
      title = this.props.title;
      let titleSplit = title.split(" ");

      if (!this.props.highlightLastWord) {
        var titleFirstPart = titleSplit[0];
        pronoun = <span className="pronoun">{titleFirstPart}</span>;
        title = title.substring(titleFirstPart.length);
      } else {
        var titleLastPart = titleSplit[titleSplit.length - 1];
        lastnoun = <span className="pronoun">{titleLastPart}</span>;
        title = title.substring(0, title.length - titleLastPart.length);
      }
    }

    return (
      <div
        className={
          "header-title" +
          (this.props.active ? " active" : "") +
          (this.props.withBorder ? " header-title-with-border" : "") +
          (this.props.small ? " header-title-small" : "") +
          (this.props.className ? " " + this.props.className : "")
        }
      >
        <h1>
          {pronoun}
          {title}
          {lastnoun}
        </h1>
        {this.props.children}
      </div>
    );
  }
}

export default HeaderTitle;
